import type { IconifyJSON } from '@iconify/vue'

/**
 * 项目自绘图标集（老钱风线条，和 solar linear 一致：24 网格、1.5 描边、圆角端点）
 * 前缀 aries，使用方式：<Icon icon="aries:xxx" />
 */
export const localIcons: IconifyJSON = {
  prefix: 'aries',
  width: 24,
  height: 24,
  icons: {
    /**
     * 花瓣流水：五瓣花（花瓣=平台货币，花=花瓣账本）
     * 单枚「圆头勺形」花瓣绕花心旋转 5 次：顶部圆润饱满、底部收拢于花心，
     * 读起来是花瓣而不是星角。
     * 2026-09-28：整体放大并光学居中，可视区域约 16.6×15.7（与 solar linear
     * 图标在 24 网格中的视觉尺寸一致），避免在宫格中显得明显偏小。
     */
    'petal-blossom': {
      body: `<g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <g transform="translate(0 2.3)">
          <g transform="matrix(1.1 0 0 1.1 -1.2 -1.05)">
          <g transform="rotate(0 12 10.5)"><path d="M10.35 8.1 C9 5.55 10.05 2.4 12 1.8 C13.95 2.4 15 5.55 13.65 8.1 C12.75 9 11.25 9 10.35 8.1 Z"/></g>
          <g transform="rotate(72 12 10.5)"><path d="M10.35 8.1 C9 5.55 10.05 2.4 12 1.8 C13.95 2.4 15 5.55 13.65 8.1 C12.75 9 11.25 9 10.35 8.1 Z"/></g>
          <g transform="rotate(144 12 10.5)"><path d="M10.35 8.1 C9 5.55 10.05 2.4 12 1.8 C13.95 2.4 15 5.55 13.65 8.1 C12.75 9 11.25 9 10.35 8.1 Z"/></g>
          <g transform="rotate(216 12 10.5)"><path d="M10.35 8.1 C9 5.55 10.05 2.4 12 1.8 C13.95 2.4 15 5.55 13.65 8.1 C12.75 9 11.25 9 10.35 8.1 Z"/></g>
          <g transform="rotate(288 12 10.5)"><path d="M10.35 8.1 C9 5.55 10.05 2.4 12 1.8 C13.95 2.4 15 5.55 13.65 8.1 C12.75 9 11.25 9 10.35 8.1 Z"/></g>
          <circle cx="12" cy="10.5" r="1.65"/>
          </g>
        </g>
      </g>`
    }
  }
}
